import {
  useWSModalCustom,
  useWSSnackbar,
  WSAlert,
  WSList,
  WSModal,
  WSModalCustomProps,
  WSText
} from "@wingspanhq/fe-component-library";
import { useHistory } from "react-router-dom";
import { useMutationConvertWorkLogs } from "../../../../query/workLog/mutations/useMutationConvertWorkLog";

type Props = {
  workLogId: string;
} & WSModalCustomProps<{
  createError?: boolean;
}>;

export const ModalConvert: React.FC<Props> = ({ workLogId, ...props }) => {
  const history = useHistory();
  const { openSnackbar } = useWSSnackbar();
  const [mutate, meta] = useMutationConvertWorkLogs();

  return (
    <WSModal
      title="Create invoice"
      actions={{
        alignment: "fill",
        buttons: [
          {
            kind: "Tertiary",
            label: "Back",
            onClick: () => {
              props.onClose({ createError: false });
            }
          },
          {
            kind: "Primary",
            label: "Yes, create invoice",
            onClick: () => {
              mutate(
                { workLogId },
                {
                  onSuccess: workLog => {
                    history.push(`/member/invoices/${workLog.invoiceId}/edit`);
                    props.onClose({ createError: false });

                    openSnackbar({
                      icon: {
                        name: "check"
                      },
                      message: "Work log converted to draft invoice"
                    });
                  },
                  onError: () => {
                    props.onClose({ createError: true });
                  }
                }
              );
            },
            loading: meta.isLoading
          }
        ]
      }}
      {...props}
    >
      <WSList gap="L">
        <WSText.ParagraphSm color="gray500">
          Are you sure you want to create an invoice for this work summary?
        </WSText.ParagraphSm>
        <WSAlert
          theme="info"
          title="About creating invoices"
          icon="info-circle"
        >
          Once an invoice is created, the work summary cannot be edited. Please
          ensure the work summary is accurate before proceeding. Continue to
          create the invoice in draft status and add optional details such as
          notes and attachments.
        </WSAlert>
      </WSList>
    </WSModal>
  );
};

export const useModalConvert = () => useWSModalCustom(ModalConvert);
